import { AxiosInstance } from "axios";
import ApiClient from "api/apiClient"

class SchoolMergeApiClient extends ApiClient{
  axiosInstance: AxiosInstance;

  constructor() {
    const baseUrl = process.env.REACT_APP_API_ROOT;
    if (baseUrl) {
      super(baseUrl);
      this.client.defaults.responseType = 'json' as const;
      this.client.defaults.headers.common = {
        'Content-Type': 'application/json',
      };
      this.client.defaults.withCredentials = true;
      this.axiosInstance = this.client;
    }
    else {
      throw new Error("REACT_APP_API_ROOT not specified");
    }
  }
}

export const schoolMergeApiClient = new SchoolMergeApiClient();